import * as React from 'react';

import { MENU_ITEM_TYPE_ACCOUNT } from '../../../../config/constants';
import { ImmutableMenuItem } from '../..';
import MenuMainItemAccount from './Account';
import MenuMainItemDefault from './Default';

import './style.scss';

interface Props {
  entity: ImmutableMenuItem;
}

const MenuMainItem: React.FC<Props> = ({ entity }) => {
  const menuItem = entity.toJS();
  const className = menuItem.link.options.attributes?.class?.[0] || '';
  const type = className.split('--')[1];

  switch (type) {
    case MENU_ITEM_TYPE_ACCOUNT:
      return <MenuMainItemAccount className={className} entity={entity} />;
    default:
      return <MenuMainItemDefault className={className} entity={entity} />;
  }
};

export default MenuMainItem;
